import { userRoles } from "../../constants";
import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  selectPersonSelectList: [],
  termsAndConditionsUrl: "",
  suspendDialog: false,
  verifiedDialog: false,
  notifications: [],
  notificationCount: 0,
  fineTransactionHistory:{},
  sponsorshipAvailability:false
};

const common = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.SEARCH_PERSON_SELECT_LIST: {
      draft.selectPersonSelectList = payload?.selectPersonSelectList;
      break;
    }

    case Actions.GET_TERMS_AND_CONDITIONS_LIST: {
      const tncList =
        (payload?.termsAndConditions &&
          payload?.termsAndConditions?.find(
            (element) => element?.type === userRoles.SERVICE_PROVIDER_ADMIN
          )?.url) ||
        "";
      draft.termsAndConditionsUrl = tncList;
      break;
    }
    case Actions.VERIFIED_DIALOG_OPEN: {
      draft.verifiedDialog = true;
      break;
    }
    case Actions.VERIFIED_DIALOG_CLOSE: {
      draft.verifiedDialog = false;
      break;
    }
    case Actions.SUSPEND_DIALOG_OPEN: {
      draft.suspendDialog = true;
      break;
    }
    case Actions.SUSPEND_DIALOG_CLOSE: {
      draft.suspendDialog = false;
      break;
    }
    case Actions.GET_FINE_TRANSACTION_HISTORY_LIST: {
      draft.fineTransactionHistory = payload?.fineTransactionHistory;
      break;
    }
    case Actions.FETCHED_ALL_NOTIFICATIONS: {
      draft.notifications = payload;
      draft.notificationCount = payload.filter(
        (item) => item.read_at === null
      ).length;
      break;
    }

    case Actions.CHECK_SPONSORSHIP_AVAILABILITY: {
      draft.sponsorshipAvailability = payload?.sponsorshipAvailability;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default common;
